package com.example.webcv.ui

import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgb
import org.jetbrains.compose.web.css.Color

object PortfolioColors {
    val background = rgb(18, 18, 18)
    val cardBg = rgb(28, 28, 28)
    val accent = rgb(255, 193, 7)
    val accentHover = rgb(255, 214, 77)
    val textPrimary = rgb(255, 255, 255)
    val textSecondary = rgb(180, 180, 180)
    val border = rgb(60, 60, 60)
    val borderLight = Color.dimgray
}
